export default {
  create: {
    success: 'Utilisateur créé avec succès',
    error: "Impossible de créer l'Utilisateur"
  },
  update: {
    success: "Modification de l'utilisateur effectué avec succès",
    error: "Impossible de mettre à jour l'utilisateur"
  },
  delete: {
    success: 'Utilisateur supprimé avec succès',
    error: "Impossible de supprimer l'utilisateur"
  }
}
